import en from './en.json'
import de from './de.json'
export default {
  en: en,
  'en-US': en,
  'en-GB': en,
  de: de,
  'de-DE': de,
}
